import { render, staticRenderFns } from "./ProjectIssues.vue?vue&type=template&id=2c478d27&scoped=true&"
import script from "./ProjectIssues.vue?vue&type=script&lang=ts&"
export * from "./ProjectIssues.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c478d27",
  null
  
)

export default component.exports